/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

export type RoadDirection = 'forward' | 'backward' | 'both';

/** Runtime constants for RoadDirection values. Use instead of string literals. */
export const ROAD_DIRECTION = {
  Forward: 'forward' as RoadDirection,
  Backward: 'backward' as RoadDirection,
  Both: 'both' as RoadDirection
} as const;

export interface IRoadDetails {
  /** Full road name from segment info (roadInfo.name). Used for same-road logic in contiguity checks. */
  fullAddress?: string | null;
  /** Street name from segment info (roadInfo.street). Used for UI display. Null when not available. */
  roadName: string | null;
  /** City name from segment info (roadInfo.city). Used for UI display. Null when not available. */
  cityName: string | null;
  speedLimitInKmh: number | null;
  direction: RoadDirection;
  distanceKm: number | null;
  speedDisplay?: string;
}
